import "./src/styles/fonts.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export const onInitialClientRender = () => {
  let body = document.getElementsByTagName("body")[0]
  body.classList.add("page-has-loaded")
}
